import React from 'react'

import String from './String'
import Bool from './Bool'
import Rte from './Rte'
import Relation from './Relation'

const RenderSetting = ({contentTypeId, setting, value, setIsDraft, setLastSaved}) => {
    return (
        <div className="cc_value_list_item">
            <div className="input_label">
                <span>{setting.settingName}</span>
            
            {
                setting.showDescription && <i>{setting.settingDescription}</i>
            }

            {
                setting.settingType === "string" && <String contentTypeId={contentTypeId} contentSetting={setting} contentValue={value} setIsDraft={setIsDraft} setLastSaved={setLastSaved}/>
            }
            {
                setting.settingType === "bool" && <Bool contentTypeId={contentTypeId} contentSetting={setting} contentValue={value} setIsDraft={setIsDraft} setLastSaved={setLastSaved}/>
            }
            {
                setting.settingType === "rte" && <Rte contentTypeId={contentTypeId} contentSetting={setting} contentValue={value} setIsDraft={setIsDraft} setLastSaved={setLastSaved}/>
            }
            {
                setting.settingType === "relation" && <Relation contentTypeId={contentTypeId} contentSetting={setting} contentValue={value} setIsDraft={setIsDraft}/>
            }            
            </div>
        </div>
    )
}

export default RenderSetting
